import { DropdownFilter } from "../../../../components/Filters/DropdownFilter";
import { CountryChooser } from "../CountriesChooser";
import { useSearchContext } from "../../contexts";
import { useTranslation } from "react-i18next";

interface CountriesChooserDropdownProps {
  onOpenChange?: (isOpen: boolean) => void;
}

export const CountriesChooserDropdown: React.FC<CountriesChooserDropdownProps> = ({ onOpenChange }) => {
  const { state } = useSearchContext();
  const { t } = useTranslation();
  return (
    <DropdownFilter
      title={t("Actor origin countries")}
      counter={state.draftFilters.countries.value.length}
      isExclude ={state.draftFilters.countries.exclude}
      onOpenChange={onOpenChange}
    >
      <CountryChooser />
    </DropdownFilter>
  )
};
